import { constants } from 'constants/constants';
import { MASK_TYPE } from '@certemy/ui-components';
import { hoursValidator } from '@certemy/common';
import { STEP_TYPES } from 'constants/status.constants';
import { defaultUnitLabel } from 'constants/log-step.constants';
import _get from 'lodash-es/get';

export abstract class LogStepBaseMixin {
  mapFields(fields, content, step_type_id) {
    const isLogStep = step_type_id === STEP_TYPES.LOG;
    let { number_required, number_completed = 0, allowMultipleEntries } = content;
    if (!isLogStep) {
      number_required = _get(content, 'dashboard.required');
      number_completed = number_required - _get(content, 'dashboard.remaining', 0);
    }
    return fields
      ? fields.map(field => {
          const { isDefault, label = isLogStep ? 'hours' : defaultUnitLabel, type, value } = field;
          if (isDefault && type && type.id === constants.FORM_FIELD_TYPE_IDS.NUMBER) {
            if (value) {
              number_completed = +(number_completed - value).toFixed(2);
            }
            const decimalValue = isLogStep ? 0.5 : 0.01;
            const additionalParams = {
              oneHundredthValidator: !isLogStep,
              min: decimalValue,
              step: decimalValue,
              hint: `Value should be multiple of ${decimalValue}`,
            };
            return {
              ...field,
              maskConfig: {
                maskType: isLogStep ? MASK_TYPE.MULTIPLE_OF_HALF : MASK_TYPE.DEFAULT,
              },
              ...(!allowMultipleEntries
                ? {
                    validators: [
                      hoursValidator({ label: label.toLowerCase(), number_required, number_completed, fraction: 2 }),
                    ],
                  }
                : {}),
              ...additionalParams,
            };
          }
          return field;
        })
      : fields;
  }
}
